// splide carousel
class SplideCarousel extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init(){
    const options = {
      type: this.dataset.type || 'slide',
      perPage: parseInt(this.dataset.perPage) || 1,
      pagination: this.dataset.pagination === 'true',
      height: this.dataset.height || null,
      perMove: parseInt(this.dataset.perMove) || 1,
      arrows: this.dataset.arrows === "true",
      gap: this.dataset.gap || '0px',
      autoplay: this.dataset.autoplay === "true",
      interval: parseInt(this.dataset.interval) || 0,
      breakpoints: {
        750: {
          perPage: parseFloat(this.dataset.breakpointsPerPage) || 1,
          padding: {right: parseInt(this.dataset.breakpointPaddingRight) } || 0,
          perMove: parseInt(this.dataset.perPage) || 1,
          height: parseFloat(this.dataset.breakpointsHeight) || null,
          gap: parseInt(this.dataset.breakpointsGap) || 15,
          arrows: this.dataset.breakpointArrow === "true",
        },
        1050:{
          perPage: 2
        }
      },
    };

    const slider = new Splide(this, options);
    slider.mount();
  }
}

customElements.define('splide-carousel', SplideCarousel);

//announcementBar  offer popup//
let offerPopup = document.querySelector('.offer__popup');
var target = document.querySelectorAll('.trigger-popup');

class AnnouncementTrigger extends HTMLElement {
  constructor() {
    super();
    const offerPopup = document.querySelector('.offer__popup');
    this.addEventListener("click",()=>{
      offerPopup.classList.remove('hidden');  
       offerPopup.classList.add('visible');  
       document.body.style.overflow = "hidden";
    })
  }
}

customElements.define("announcement-trigger", AnnouncementTrigger);

var element = document.querySelectorAll('.trigger-popup p.announcement-bar__message');

for (var i = 0; i < element.length; i++) {
  // Add a click event listener to each element
  
  element[i].addEventListener("click", function(event) {
      offerPopup.classList.remove('hidden');  
      offerPopup.classList.add('visible');  
      document.body.style.overflow = "hidden";
  });
}

document.querySelector('.close__offer-popup')?.addEventListener('click',()=>{
  offerPopup.classList.remove('visible');  
  offerPopup.classList.add('hidden');  
  document.body.style.overflow = "";
});

offerPopup?.addEventListener('click', (event) => {
  const clickedElement = event.target;
  if(clickedElement.closest(".hover-eff")) {
    return;
  } else {
    offerPopup.classList.remove('visible'); 
    offerPopup.classList.add('hidden');
    document.body.style.overflow = "";
  }
});

// announcemnetBar timer 
class CountDown extends HTMLElement {
  constructor() {
    super();
    this.initCountDown()
  }

  initCountDown() {
    this.endYear = this.dataset.endyear || 2026;
    this.endMonth = this.dataset.endmonth || 0;
    this.endDay = this.dataset.endday || 1;
    this.endHour = this.dataset.endhour || 0;
    this.endMinute = this.dataset.endminute || 0;
    this.countdownFormat = this.dataset.countdownformat || `Last Day Sale In: {days}days {hours}hrs {minutes}mins {seconds}sec`;

    var countDownDate = new Date(this.endYear, this.endMonth, this.endDay, this.endHour, this.endMinute).getTime();

    // Update the count down every 1 second
    let offerCountDownData = {}

    offerCountDownData.countDownFunction = setInterval( () => {
  
      // Get today's date and time
      var now = new Date().getTime();
  
      // Find the distance between now and the count down date
      var distance = countDownDate - now;
  
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
      this.innerHTML = this.countdownFormat.replace('{days}', days).replace('{hours}', hours).replace('{minutes}', minutes).replace('{seconds}', seconds)
      //this.innerText = this.countdownFormat
      
      // If the count down is finished, write some text
      if (distance < 0) {
      clearInterval(offerCountDownData.countDownFunction);
      this.innerHTML = "FLASHSALE END";
      }
    }, 1000);
  }
}

customElements.define('count-down', CountDown);	

// on hover display megamenu //
document.querySelectorAll(".mega-menu").forEach((element) => {
  element.addEventListener("mousemove",function(event){
    document.querySelectorAll(".mega-menu").forEach((element) => {
     element.removeAttribute("open");
    });
    let currentElement = event.srcElement;
    let details = currentElement.closest(".mega-menu");
    details.setAttribute("open"," ");
  });
});

/* ----------- megamenu start --------- */
document.querySelectorAll(".mega-menu").forEach((element) => {
  element.addEventListener("mouseout",function(event){
    document.querySelectorAll(".mega-menu").forEach((element) => {
     element.removeAttribute("open");
    });
  });
});

document.querySelectorAll(".mega-menu__content").forEach((element) => {
  element.addEventListener("mouseout",function(event){
    // console.log(event.srcElement);
    let currentElement = event.srcElement;
    let details = currentElement.closest(".mega-menu");
    details.removeAttribute("open");
  });
});

/* ----------- megamenu end --------- */

// hamburger menu button function//
 document.querySelector('#mobilemenu_close').addEventListener('click',()=>{
  document.querySelector('.header__icon--summary').click();
});

const details = document.querySelectorAll(".details-toglle-arrow");
const scrollContainer = document.querySelector(".menu-drawer__navigation-container");

details.forEach((targetDetail) => {
  const summary = targetDetail.querySelector("summary");
  const content = targetDetail.querySelector(".menu-drawer__inner-submenu");

  content.style.overflow = "hidden";
  content.style.transition = "height 0.5s ease-in-out";
  content.style.height = "0";

  summary.addEventListener("click", (e) => {
    e.preventDefault();

    const isOpen = targetDetail.hasAttribute("open");

    // Close all other accordions
    details.forEach((detail) => {
      if (detail !== targetDetail) {
        detail.removeAttribute("open");
        const otherContent = detail.querySelector(".menu-drawer__inner-submenu");
        if (otherContent) {
          otherContent.style.height = "0";
        }
      }
    });

    if (!isOpen) {
      targetDetail.setAttribute("open", true);
      content.style.height = content.scrollHeight + "px";

      content.addEventListener(
        "transitionend",
        () => {
          if (targetDetail.hasAttribute("open")) {
            content.style.height = "auto";

            // Check if content is fully in view of the scroll container
            const containerRect = scrollContainer.getBoundingClientRect();
            const contentRect = content.getBoundingClientRect();

            const isContentFullyVisible =
              contentRect.top >= containerRect.top &&
              contentRect.bottom <= containerRect.bottom;

            if (!isContentFullyVisible) {
              const detailRect = targetDetail.getBoundingClientRect();
              const topOffsetInContainer = detailRect.top - containerRect.top;
              const containerHeight = scrollContainer.clientHeight;
              const scrollTo = scrollContainer.scrollTop + topOffsetInContainer - containerHeight * 0.2;

              scrollContainer.scrollTo({
                top: scrollTo,
                behavior: "smooth"
              });
            }
          }
        },
        { once: true }
      );
    } else {
      content.style.height = content.scrollHeight + "px";

      requestAnimationFrame(() => {
        content.style.height = "0";
      });

      content.addEventListener(
        "transitionend",
        () => {
          targetDetail.removeAttribute("open");
        },
        { once: true }
      );
    }
  });
});

/* scroll to top button js */
const scrollBtn = document.createElement("button");
scrollBtn.innerHTML =
  '<svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m9.001 10.978h-3.251c-.412 0-.75-.335-.75-.752 0-.188.071-.375.206-.518 1.685-1.775 4.692-4.945 6.069-6.396.189-.2.452-.312.725-.312.274 0 .536.112.725.312 1.377 1.451 4.385 4.621 6.068 6.396.136.143.207.33.207.518 0 .417-.337.752-.75.752h-3.251v9.02c0 .531-.47 1.002-1 1.002h-3.998c-.53 0-1-.471-1-1.002z" fill-rule="nonzero"/></svg>';
scrollBtn.setAttribute("id", "scroll-btn");
document.body.appendChild(scrollBtn);

const scrollBtnDisplay = function () {
  const scrollY = window.scrollY || window.pageYOffset; // Compatibility with Safari
  window.innerHeight <= scrollY
    ? scrollBtn.classList.add("show")
    : scrollBtn.classList.remove("show");
};

window.addEventListener("scroll", scrollBtnDisplay);
window.addEventListener("touchmove", scrollBtnDisplay); // For iOS Safari

const scrollWindow = function () {
  const scrollY = window.scrollY || window.pageYOffset; // Compatibility with Safari
  if (scrollY !== 0) {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }
};

scrollBtn.addEventListener("click", scrollWindow);

//splide slider initializaton for special collection section
class CollectionSlider extends HTMLElement{
  constructor(){
    super()
    this.init()
  }

  init() {
    const specialCollectionSlider = this.querySelector('.special_collection_splider');
    this.gap = parseInt(this.getAttribute('data-gap'));
    this.desktopPerPage = this.getAttribute("data-desktop-perpage");

    const bannerSliderOptions = {
      type: 'slide',
      perPage: 2,
      perMove: 2,
      gap: this.gap || 0,
      mediaQuery: 'min',
      pagination: false,
      arrows: true,
      breakpoints: {
        990: {
          type: 'slide',
          perPage: this.desktopPerPage || 4,
          perMove: 4,
          gap: '1.5rem',
          pagination: true, // Enable pagination with dots for screens wider than 990px
        },
        750: {
          perPage: 3,
          gap: '1.5rem',
          pagination: true, // Enable pagination with dots for screens wider than 750px
          arrows: true,
        }
      }
    }
    
    let specialColSlide = new Splide(specialCollectionSlider, bannerSliderOptions);
    specialColSlide.mount();
  }
}

customElements.define('collection-slider', CollectionSlider);


// rewards popup 
document.addEventListener('DOMContentLoaded', function() {
  function closePopup() {
      document.body.style.overflow = 'unset';
      document.querySelector('.earn-reward-container').style.display = 'none';
  }

  document.querySelector('#earn-now')?.addEventListener('click', function() {
      document.body.style.overflow = 'hidden';
      document.querySelector('.earn-reward-container').style.display = 'flex';
  });

  document.querySelector('.popup-close-rewards').addEventListener('click', function() {
      closePopup();
  });

  document.querySelector('.earn-reward-container').addEventListener('click', function(event) {
      if (event.target.classList.contains('earn-reward-container')) {
          closePopup();
      }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // banner slider splide 
  class BannerSlider extends HTMLElement{
    constructor(){
      super()
      this.init()
    }
  
    init(){
      const bannerSlider = this.querySelector('.banner_slider_splide');

      if (bannerSlider) {        
        const paginationValue = bannerSlider.getAttribute('data-pagination') === 'true' || false;
        
        const bannerOptions = {
          perPage: 1,
          type: "loop",
          speed: 400,
          autoplay: true,
          pagination: paginationValue
        }
        
        let specialColSlide = new Splide(bannerSlider, bannerOptions );
        specialColSlide.mount();
        
        // DATALAYER FOR HOMEPAGE BANNER STARTS
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
          window.deviceName = 'Mobile';
        } else {
          window.deviceName = 'Desktop';
        }
        
        // previous page link and page type
        var prevlink = document.referrer;
        var prevpageType = '';
      
        if(prevlink == 'https://www.mcaffeine.com/'){
          prevpageType = "Home Page"
        }
        else if(prevlink.includes("collection")){
          prevpageType = "Collection Page"
        }
        else if(prevlink.includes("products")){
          prevpageType = "Product Page"
        }
        else if(prevlink.includes("page")){
          prevpageType = "Static Page"
        }
        else{
          prevpageType = "NA"
        }
    
        // customer order count and type
        let orderCount = "{{ customer.orders_count}}";
        let userType = '';
      
        if (orderCount < 1 || undefined){
          userType = "New"
        }
        else{
          userType = "Old"
        }
        
        specialColSlide.on('move', function() {
          let trackingDivParent = document.querySelector(".banner_slider_splide");
          let trackingDiv = trackingDivParent.querySelector('.banner_slider .splide__slide.is-active');
      
          var promoData = {
            'promotion_id': trackingDiv.getAttribute('data-desktop-tracking-id'),
            'promotion_name': trackingDiv.getAttribute('data-desktop-tracking-name'),
            'creative': trackingDiv.getAttribute('data-desktop-tracking-creative'),
            'position': trackingDiv.getAttribute('data-desktop-tracking-position')
          }
          
          if(window.deviceName == 'Mobile') {
            promoData = {
              'id': trackingDiv.getAttribute('data-mobile-tracking-id'),
              'name': trackingDiv.getAttribute('data-mobile-tracking-name'),
              'creative_name': trackingDiv.getAttribute('data-mobile-tracking-creative'),
              'creative_slot': trackingDiv.getAttribute('data-mobile-tracking-position')
            }
          }
      
          dataLayer.push({
            event: "view_promotion",
            previous_page_type: prevpageType,
            user_Type: userType,
            'ecommerce': {
              'items': [promoData]
            }
          });
        });
        // DATALAYER FOR HOMEPAGE BANNER ENDS
      }
    }
  }
  
  customElements.define('banner-slider', BannerSlider);
});

document.addEventListener( 'DOMContentLoaded', function() {
  // special collection filter tabs section
  class ProductFilterTabs extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.splideInit();
      this.filterTabsTrigger();
    }
  
    splideInit() {
      let shopByConcernsItems = document.querySelectorAll('.splideConcern');

      shopByConcernsItems.forEach((element) => {
        new Splide(element, {
          type: 'slide',
          perPage: 4,
          perMove: 1,
          pagination: false,
          breakpoints: {
            750: {
              pagination: true,
              arrows: true,
            },
            480: {
              perPage: 1,
              grid: {
                rows: 2,
                cols: 2
              },
            },
          },
        }).mount(window.splide.Extensions);
      });
    }
  
    filterTabsTrigger() {
      const tabsHeadings = document.querySelectorAll('.tabs_heading');
  
      const toggleTab = (tabIndex) => {
        const toggleContainer = (containers, index) => {
          containers.forEach((container, i) => {
            const shouldAddClass = i + 1 === index;
            container.classList.toggle('active-tab', shouldAddClass);
          });
        };
  
        toggleContainer(document.querySelectorAll('.tabs_container'), tabIndex);
        toggleContainer(document.querySelectorAll('.splideConcern'), tabIndex);
  
        tabsHeadings.forEach((tabHeading, index) => {
          tabHeading.classList.toggle('active-tab-heading', index + 1 === tabIndex);
        });
      };
  
      tabsHeadings.forEach((tabHeading, index) => {
        tabHeading.addEventListener('click', () => toggleTab(index + 1));
      });
  
      tabsHeadings[0].click();
    }
  }
  
  customElements.define('product-filter-tabs', ProductFilterTabs);

  // Explore our categories section
  class exploreOurCategories extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.splideInit();
    }
  
    splideInit() {
      let exploreCategoriesItems = document.querySelectorAll('#imageCarousel');
  
      exploreCategoriesItems.forEach((element) => {
        new Splide(element, {
          perPage: 3,
          perMove: 1,
          pagination: true, // Enable slider dots
          gap: 15,
          drag: 'free',
          snap: true,
          arrows: true,
          breakpoints: {
            750: {
              perPage: 2, // Show two slides per dot on mobile
              perMove: 1, // Slide two items at a time on mobile
              gap: 10,
              padding: {
                right: 0
              }
            }
          },
        }).mount();
      });
    }
  }
  
  customElements.define('explore-our-categories', exploreOurCategories);

  // Revamp testimonial section
  class revampTestimonialSection extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.splideInit();
      this.querySelector(".testimonial-product-link").addEventListener('click', this.addDatalayerEvent.bind(this));
    }
  
    splideInit() {
      let testimonialItems = document.querySelectorAll('#testimonial_slider');
  
      testimonialItems.forEach((element) => {
        new Splide(element, {
          type: 'slide',
          perPage: 3,
          pagination: true,
          autoplay:false,
          interval:1000,
          perMove: 1,
          arrows: false,
          gap: '50px',
          padding: '10px',  
          breakpoints: {
            1279:{
              perPage: 2,
              perMove: 1           
            },
            480:{
              perPage: 1,
              gap: '10px',
              perMove: 1
            }
          }
        }).mount();
      });
    }

    addDatalayerEvent(){

      const product = this.querySelector(".testimonial-product-link");
      const cartValue = document.querySelector(".cart-drawer__footer .totals__subtotal-value span").textContent;
      const clevertapData = {
        Product_Name: product.dataset.productName,
        PDP_Link: product.dataset.pdpLink,
        Cart_Value: cartValue
      }

      dataLayer.push({
        event: "Testimonials_Shop",
        Product_Name: product.dataset.productName,
        PDP_Link: product.dataset.pdpLink,
        Cart_Value: cartValue,
        clevertap: clevertapData
      });
    }
  }
  
  customElements.define('revamp-testimonial-section', revampTestimonialSection);

  // empty cart

  class emptyCartUpsell extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.splideInit();
    }

    // Splide init() function
    splideInit() {
      const emptyCartUpsellSplide = new Splide('.emptyCart-upsell__wrapper', {
        perPage: 2,
        perMove: 1,
        pagination: false,
        type: 'splide',
        arrows: true,
        snap   : true,
        breakpoints: {
          750: {
            arrows: false,         
          },
        },
      });

      emptyCartUpsellSplide.mount();
    }
  }

   customElements.define('empty-cart-upsell', emptyCartUpsell);
})


// product list tabs custom element

class FeaturedTabs extends HTMLElement {
  constructor() {
    super();
    this.tabNames = this.querySelectorAll('.ft-tab_name');
    this.tabContents = this.querySelectorAll('.ft_content');
    this.setupTabs();
  }

  setupTabs() {
    this.tabNames.forEach((tabName, index) => {
      tabName.addEventListener('click', () => this.showTab(tabName, index));
      tabName.addEventListener('keydown', (event) => {
        if (event.code === 'Enter' || event.code === 'Space') {
          this.showTab(index);
        }
      });
    });
  }

  showTab(tabName, index) {
    this.tabNames.forEach((tabName, i) => {
      tabName.setAttribute('aria-selected', i === index);
      tabName.setAttribute('tabindex', i === index ? 0 : -1);
    });

    this.tabContents.forEach((content, i) => {
      content.setAttribute('aria-hidden', i !== index);
    });

    const cartValue = document.querySelector(".cart-drawer__footer .totals__subtotal-value span").textContent;
    const clevertapData = {
      Block_Title: tabName.dataset.blockTitle,
      Left_Image: tabName.dataset.imageUrl,
      Product_Names: tabName.dataset.productTitles,
      Cart_Value: cartValue,
      Collection_Linked: tabName.dataset.collectionName
    }

    dataLayer.push({
      event: "Category_Tab",
      Block_Title: tabName.dataset.blockTitle,
      Left_Image: tabName.dataset.imageUrl,
      Product_Names: tabName.dataset.productTitles,
      Cart_Value: cartValue,
      Collection_Linked: tabName.dataset.collectionName,
      clevertap: clevertapData
    });
  }
}

customElements.define('featured-tabs', FeaturedTabs);


// splide structure

{/* <splide-carousel
data-type="slide"
data-per-page="4"
data-pagination="false"
data-autoplay="false"
data-interval="1000"
data-per-move="1"
data-arrows="false"
data-gap="25px"
data-padding="10px"
data-breakpoints-per-page="2"
class="splide"
>
<div class="splide__track">
  <ul class="splide__list">
      <li class="splide__slide">
      </li>
  </ul>
</div>
</splide-carousel> */}

// video carousel

class VideoCarousel extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init(){
    const options = {
      type: 'loop',
      focus: 'center',
      waitForTransition: false,
      perPage: 5,
      speed: 100,
      height: '',
      pagination: false,
      perMove: 1,
      arrows: false,
      gap: '0px',
      updateOnMove:true,
      breakpoints: {
        750: {
          perPage: 3,
          perMove: 1,
          arrows: false
        },
      },
    };

    const slider = new Splide(this, options);
    slider.mount();
  }
}

customElements.define('video-carousel', VideoCarousel);

document.addEventListener('DOMContentLoaded', function() {
  const targetElement = document.querySelector('.vs_main');

  if (targetElement) {
      const observer = new IntersectionObserver(function(entries, observer) {
          entries.forEach(entry => {
              if (entry.isIntersecting) {
                  const videoCarousel = document.querySelector('video-carousel');
                  if (videoCarousel) {
                      videoCarousel.init();
                      observer.disconnect();  // Stop observing after init is called once
                  }
              }
          });
      });

      observer.observe(targetElement);
  }
});

// sticky atc new lipstick template

// window.initMobileCartObserver = function() {
//   const targetElementA = document.querySelector('.coupon') || document.querySelector('custom-color-swatch');
//   const mobileCartButton = document.querySelector('.mobile-cart-button.large-up-hide.medium-hide');

//   // Create the Intersection Observer callback function

//   if(targetElementA){
//   const observerCallback = (entries, observer) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         mobileCartButton.style.display="none";
//       } else {
//         mobileCartButton.style.display="block";
//       }
//     });
//   };

//   // Create an Intersection Observer instance
//   const observer = new IntersectionObserver(observerCallback, {
//     root: null,
//     threshold: 0.7
//   });

//   // Start observing the target element
//   observer.observe(targetElementA);
//   }
// }

// lightning deal CountDown
class CountDownPdp extends HTMLElement {
  constructor() {
    super();
    this.initCountDown()
  }

  initCountDown() {
    this.endYear = this.dataset.endyear || 2026;
    this.endMonth = this.dataset.endmonth || 0;
    this.endDay = this.dataset.endday || 1;
    this.endHour = this.dataset.endhour || 0;
    this.endMinute = this.dataset.endminute || 0;
    this.countdownFormat = this.dataset.countdownformat || `Offer ends in {days}days {hours}hrs {minutes}mins {seconds}sec`;

    var countDownDate = new Date(this.endYear, this.endMonth, this.endDay, this.endHour, this.endMinute).getTime();

    // Update the count down every 1 second
    let offerCountDownData = {}

    offerCountDownData.countDownFunction = setInterval(() => {

      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.innerHTML = this.countdownFormat.replace('{days}', days).replace('{hours}', hours).replace('{minutes}', minutes).replace('{seconds}', seconds);
      
      const regularPrice = document.querySelector("#regular__price");
      const dataRegular = regularPrice?.getAttribute("data-discountPercentage");
      if (dataRegular > 0){
        regularPrice.classList.add("selling_price_discount");
      }

      const sellingPrice = document.querySelector("#selling__price_pdp");
      const dataSelling = sellingPrice?.getAttribute("data-discountPercentage");
      if (dataSelling > 0){
        sellingPrice.classList.add("selling_price_discount");
      }
      
      const cardPriceElements = document.querySelectorAll(".card-information .price-item--regular");
      const collectionPriceElements = document.querySelectorAll(".mmc-card-price .mm-product-price");
      const collectionSalePriceElements = document.querySelectorAll(".mmc-card-price .mm-sale-price");
      const allCountdowns = document.querySelectorAll(".countdown-container-pdp"); 
      const extraOff = document.querySelectorAll(".main-product-flex-extra-off");
      const cartExtraOff = document.querySelectorAll(".percent-off-text");
      const cartCountdown = document.querySelectorAll(".cart-item-countdown");
      if (cartCountdown.length > 0) {
        cartCountdown.forEach(ele =>{
           ele.style.visibility="visible";
           ele.style.display="flex"; 
            
        })
      }
      if (cartExtraOff.length > 0) {
        cartExtraOff.forEach(ele =>{
             ele.style.visibility="visible";
             ele.style.display="flex";          
        })
      }
       if (extraOff.length > 0) {
        extraOff.forEach(ele =>{
             ele.style.visibility="visible";
             ele.style.display="flex";         
        })
      }
      if (allCountdowns.length > 0) {
        allCountdowns.forEach(ele =>{
            ele.style.visibility="visible";
             ele.style.display="flex";
        })
      }
      if (cardPriceElements) {
          cardPriceElements.forEach(element => {
          const dataPercent = element.getAttribute("data-discountpercentage");
          if (dataPercent > 0) {
            element.classList.add("selling_price_discount");            
          }
        });
      }
      if (collectionPriceElements) {
        collectionPriceElements.forEach(element => {
          const dataPercent = element.getAttribute("data-discountpercentage");
          if (dataPercent > 0) {
            element.classList.add("selling_price_discount");            
          }
        });
      }
      if (collectionSalePriceElements) {
        collectionSalePriceElements.forEach(element => {
          const dataPercent = element.getAttribute("data-discountpercentage");
          if (dataPercent > 0) {
            element.classList.add("selling_price_discount");            
          }
        });
      }
        const productPriceElements = document.querySelectorAll(".cart-drawer .product-option.product_price");
        productPriceElements.forEach(element => {
            element.style.fontSize = "1.4rem";
        });     
      //this.innerText = this.countdownFormat

      // If the count down is finished, write some text
      if (distance < 0) {
        this.innerHTML = "FLASHSALE END";
        clearInterval(offerCountDownData.countDownFunction);
        // window.countdownTimer();
        document.querySelector(".text-white").innerText = "";
        sessionStorage.setItem('flashSaleEnded', 'true');
        // flashsalecollection = true;
        productPriceElements.forEach(element => {
            element.style.fontSize = "1.6rem";
        });     
      }
    }, 1000);
  }
}

customElements.define('count-down-pdp', CountDownPdp);

// sticky ATC

// document.addEventListener('DOMContentLoaded', () => {
//   window.initMobileCartObserver();
// });

// CollectionLinkFilter

class CollectionLinkFilter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick);
  }

  handleClick() {
    const sectionId = this.getAttribute('data-section-id');
    const url = `${this.getAttribute('data-url')}?section_id=${sectionId}`;
    const allFilters = document.querySelectorAll('collection-link-filter');
    
    allFilters.forEach(filter => {
      filter.classList.remove('custom_active');
    });

    // Add custom_active class to the clicked element
    this.classList.add('custom_active');
      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.text();
        })
        .then(data => {
          document.getElementById('product-grid').innerHTML = new DOMParser().parseFromString(data, 'text/html').getElementById('product-grid').innerHTML;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
  }
}
customElements.define('collection-link-filter', CollectionLinkFilter);

// color swatch
class VariantCard extends HTMLElement {
  constructor() {
    super();
    this.selectedSwatch = null;
    this.originalContent = null;
  }

  connectedCallback() {
    this.originalContent = this.innerHTML;
    this.addEventListeners();
    this.moveFirstSwatchToStart();
  }

  addEventListeners() {
    this.addEventListener('click', (event) => {
      const clickedSwatch = event.target.closest('color-swatch');
      if (clickedSwatch && this.selectedSwatch !== clickedSwatch) {
        this.updateCard(clickedSwatch);
        this.updateIconTick(clickedSwatch);
        this.selectedSwatch = clickedSwatch;
      }
    });
  }
  moveFirstSwatchToStart() {
    const variantsContainer = this.querySelector('.variants_container'); 
    let firstSwatch = null;
    if (variantsContainer) {
      firstSwatch = variantsContainer.querySelector('.first-swatch'); 
    }
    if (firstSwatch) {
      variantsContainer.insertBefore(firstSwatch, variantsContainer.firstChild);
    }
  }
  updateCard(swatch) {
    if (!swatch) return;

    const productImage = swatch.getAttribute("data-product-image");
    const productTitle = swatch.getAttribute("data-product-title");
    const productSubtitle = swatch.getAttribute("data-product-subtitle");
    const productPrice = swatch.getAttribute("data-product-price");
    const productId = swatch.getAttribute("data-variant-id");
    const productHandle = swatch.getAttribute("data-product-handle");
    const productAvailable = swatch.getAttribute("data-available");
    const isPreeOrder = swatch.getAttribute("data-isPreOrder");
    const isNotifyMe = swatch.getAttribute("data-isNotifyMe");

    this.updateImage(productImage);
    this.updateText('.custom-product-title', productTitle);
    this.updateText('.mCaffeine__meta-tags', productSubtitle);
    this.updateText('.price-item', productPrice);
    this.updateProductForm(swatch, productId);
    this.updateProductUrl(productHandle);
    this.updateBadge(productAvailable,isPreeOrder);
    this.updateForms(productAvailable,isNotifyMe);
  }

  updateForms(productAvailable,isNotifyMe){
    let productForm = this.querySelector(".product-form");
    let notifymeForm = this.querySelector(".notify-me-form");

    if (productForm && notifymeForm) {
      if (productAvailable == "true" ) {
        productForm.classList.remove("hidden")
        notifymeForm.classList.add("hidden");
      }
      else {
        productForm.classList.add("hidden")
        notifymeForm.classList.remove("hidden"); 
      }
    }
  }

  updateBadge(productAvailable , isPreeOrder){
    let soldOutBadge = this.querySelector(".out-of-stock-badge");
    if(soldOutBadge){
      if (productAvailable == "true"){
        soldOutBadge.classList.add("hidden");
      }
      else{
        soldOutBadge.classList.remove("hidden");
      }
    }

    let preorderBadge = this.querySelector(".preorder-badge");
    if(preorderBadge && isPreeOrder=='true'){
      preorderBadge.classList.remove("hidden");
    }
    else{
      preorderBadge.classList.add("hidden");
    }
  }

  updateImage(imageHtml) {
    const imageContainer = this.querySelector(".card__media");
    if (imageContainer) {
      imageContainer.innerHTML = imageHtml;
    }
  }

  updateText(selector, text) {
    const element = this.querySelector(selector);
    if (element) {
      element.textContent = text;
    }
  }

  updateProductForm(swatch, productId) {
    const productForm = this.querySelector("product-form form");
    if (productForm) {
      const hiddenInput = productForm.querySelector("input.product-variant-id");
      const submitButton = productForm.querySelector("button.quick-add__submit");

      if (hiddenInput) {
        hiddenInput.value = productId;
        hiddenInput.disabled = swatch.getAttribute("data-available") === "false";
      }

      if (submitButton) {
        const isAvailable = swatch.getAttribute("data-available") !== "false";
        const isPreOrder = swatch.getAttribute("data-isPreOrder");
        submitButton.disabled = !isAvailable;
        this.querySelector("product-form").setAttribute("data-isPreeOrder",isPreOrder)
        
        const submitButtonSpan = submitButton.querySelector("span");
        if (submitButtonSpan) {
          submitButtonSpan.textContent = isAvailable 
            ? (isPreOrder === "true" ? "Pre order" : "Add to Cart") 
            : "Sold Out";
        }        
      }
    }
  }

  updateProductUrl(productHandle){
    const productNavElement = this.querySelector(".variant-card__nav-link");
    const productTitleNavElement = this.querySelector(".variant-card_title-link");
    const productSubTitleNavElement = this.querySelector(".variant-card_subtitle-link");
    productNavElement.href = `${window.location.host}/products/${productHandle}`;
    productTitleNavElement.href = `${window.location.host}/products/${productHandle}`;
    productSubTitleNavElement.href = `${window.location.host}/products/${productHandle}`;
  }

  updateIconTick(clickedSwatch) {
    this.querySelectorAll("color-swatch .icon-tick").forEach((iconTick) => {
      iconTick.style.display = "none";
    });

    const clickedIconTick = clickedSwatch.querySelector(".icon-tick");
    if (clickedIconTick) {
      clickedIconTick.style.display = "block";
    }
  }

  // Method to reset the card to its original state if needed
  resetCard() {
    if (this.originalContent) {
      this.innerHTML = this.originalContent;
      this.addEventListeners();
    }
  }
}

customElements.define("variant-card", VariantCard);

// faq tabs
class BlockTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('.faq-tab');
    this.contents = this.querySelectorAll('.faq-content');
    this.faqContainer = this.querySelector('.faq-tabs-container');
  }

  connectedCallback() {
    this.setupEventListeners();
    this.setupDocumentClickListener();
    this.setupDetailsListeners();
  }

  setupEventListeners() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', event => {
        event.stopPropagation(); // Prevent the document click event
        this.handleTabClick(tab);
      });
    });
  }

  handleTabClick(clickedTab) {
    const tabName = clickedTab.getAttribute('data-tab');
    
    this.contents.forEach(content => {
      content.style.display = 'none';
      // Close all details in other tabs
      content.querySelectorAll('details').forEach(detail => {
        detail.open = false;
      });
    });
    
    const targetContent = this.querySelector(`#${tabName}`);
    targetContent.style.display = 'flex';

    // If there's an open details, keep it open. Otherwise, open the first one.
    const openDetails = targetContent.querySelector('details[open]');
    if (openDetails) {
      openDetails.open = true;
    } else {
      const firstDetails = targetContent.querySelector('details');
      if (firstDetails) {
        firstDetails.open = true;
      }
    }
    
    this.tabs.forEach(tab => tab.classList.remove('active-block'));
    clickedTab.classList.add('active-block');   

    if (window.innerWidth <= 768) { 
      this.tabs[this.tabs.length - 3].scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      this.faqContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }  
  }

  setupDetailsListeners() {
    this.contents.forEach(content => {
      content.addEventListener('click', event => {
        if (event.target.closest('summary')) {
          const clickedDetails = event.target.closest('details');
          content.querySelectorAll('details').forEach(details => {
            if (details !== clickedDetails) {
              details.open = false;
            }
          });
        }
      });
    });
  }
  
  showDefaultTab() {
    if (this.tabs.length > 0) {
      this.handleTabClick(this.tabs[0]);
    }
  }

  setupDocumentClickListener() {
    document.addEventListener('click', event => {
      if (!this.contains(event.target)) {
        this.contents.forEach(content => {
          // content.style.display = 'none';
          document.querySelector('body').scrollIntoView({ behavior: 'smooth'});
        });
        this.tabs.forEach(tab => tab.classList.remove('active-block'));
      }
    });
  }
}

customElements.define('block-tabs', BlockTabs);

// section lazy loading
class LazySection extends HTMLElement {
  static sectionsToFetch = [];

  constructor() {
    super();

    this.section = this.closest('section')?.id || this.closest('[id]').id;
    this.section = this.section?.replace('shopify-section-', '');

    this.trigger = this.dataset.triggerEvent || 'intersection-observer';
    this.targetSelector = this.dataset.triggerTarget || 'body';

    this.boundHandleMouseover = this.handleMouseover.bind(this);
    this.boundHandleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    const targetElement = document.querySelector(this.targetSelector);

    // Different triggers based on data-trigger attribute
    if (this.trigger === 'mouseover') {
      if (screen.width < 990) return;
      
      targetElement.addEventListener('mouseover', this.boundHandleMouseover);
    } else if (this.trigger === 'click') {
      targetElement.addEventListener('click', this.boundHandleClick);
    } else {
      // Default to intersection observer
      new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  // Handler for intersection-observer trigger
  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.fetchSections();
  }

  // Handler for mouseover trigger
  handleMouseover() {
    // Remove trigger once added to sectionsToFetch
    this.removeTrigger();
    this.fetchSections();
  }

  // Handler for click trigger
  handleClick() {
    // Remove trigger once added to sectionsToFetch
    this.removeTrigger();
    this.fetchSections();
  }

  // Common function for fetching sections
  fetchSections() {
    LazySection.sectionsToFetch.push(this.section);
    const sectionsToFetchBatch = LazySection.sectionsToFetch.length == 5 ? LazySection.sectionsToFetch.splice(0, 5) : LazySection.sectionsToFetch;

      // Check if there is an ongoing network request
    if (LazySection.abortController) {
      LazySection.abortController.abort();
    }

    LazySection.abortController = sectionsToFetchBatch.length < 5 && new AbortController();

    fetch(window.location.pathname + '?sections=' + sectionsToFetchBatch.join(','), LazySection.abortController.signal ? { signal: LazySection.abortController.signal } : {})
      .then((response) => response.json())
      .then((json) => {
        for (const [key, value] of Object.entries(json)) {
          const sectionContent = new DOMParser().parseFromString(value, 'text/html').getElementById('shopify-section-' + key);

          if (sectionContent && sectionContent.innerHTML.trim().length) {
            const section = document.getElementById('shopify-section-' + key);
            section.style.opacity = '0';
            section.style.transition = 'opacity 0.3s ease-in-out';
            section.innerHTML = sectionContent.innerHTML;
            requestAnimationFrame(() => {
              section.style.opacity = '1';
            });

            if (
              section.querySelector('.custom-footer_revamp-wrapper') &&
              new URLSearchParams(window.location.search).get('customer_posted') === 'true'
            ) {
              const newsletterForm = section.querySelector(
                '.footer-newsletter-form'
              );

              if (newsletterForm) {
                newsletterForm.insertAdjacentHTML(
                  'beforeend',
                  `<div class="footer-newsletter-form__message footer-newsletter-form__message--success">
                    Thank you for subscribing!
                  </div>`
                );

                newsletterForm.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center'
                });
              }
            }

              // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
            section.querySelectorAll('script').forEach((oldScriptTag) => {
              const newScriptTag = document.createElement('script');
              Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
              });
              newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
              oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
            });
          }
        }

        if (sectionsToFetchBatch.length < 5)
          LazySection.sectionsToFetch = [];
      })
      .catch((e) => {
        console.warn(e);
      });
  }

  // Remove trigger based on data-target attribute
  removeTrigger() {
    const targetElement = document.querySelector(this.targetSelector);

    if (targetElement) {
      targetElement.removeEventListener('mouseover', this.boundHandleMouseover);
      targetElement.removeEventListener('click', this.boundHandleClick);
    }
  }
}

customElements.define('lazy-section', LazySection);

// confetti shooter

window.confettiShooter = function (useLottie = false) {
  const cartDrawer = document.querySelector('cart-drawer .drawer__inner');
  if (!cartDrawer) return;

  // If Lottie confetti is preferred
  if (useLottie) {
    showInnerConfettiCart();
    return;
  }

  // Default Canvas Confetti
  const canvas = document.createElement("canvas");
  cartDrawer.appendChild(canvas);

  const rect = cartDrawer.getBoundingClientRect();
  canvas.width = rect.width;
  canvas.height = rect.height;
  canvas.style.position = "absolute";
  canvas.style.top = "0";
  canvas.style.left = "0";
  canvas.style.width = "100%";
  canvas.style.height = "100%";
  canvas.style.pointerEvents = "none";
  canvas.style.zIndex = "9999";

  const myConfetti = confetti.create(canvas, { resize: true, useWorker: true });

  const count = 100,
    defaults = {
      origin: { y: 1 },
    };

  function fire(particleRatio, opts) {
    myConfetti(
      Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * particleRatio),
      })
    );
  }

  fire(0.25, {
    spread: 26,
    startVelocity: 55,
  });

  fire(0.2, {
    spread: 60,
  });

  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  });

  setTimeout(() => {
    canvas.style.transition = "opacity 1s ease-out";
    canvas.style.opacity = "0";
    setTimeout(() => {
      canvas.remove();
    }, 1000);
  }, 2000);
};

function showInnerConfettiCart() {
  let svgContainer = document.getElementById('confetti_svg');

  if (!svgContainer) {
    svgContainer = document.createElement('div');
    svgContainer.id = 'confetti_svg';
    svgContainer.style.position = 'absolute';
    svgContainer.style.top = '0';
    svgContainer.style.left = '0';
    svgContainer.style.width = '100%';
    svgContainer.style.height = '100%';
    svgContainer.style.pointerEvents = 'none';
    svgContainer.style.zIndex = '9999';
    document.querySelector('cart-drawer .drawer__inner').appendChild(svgContainer);
  }

  svgContainer.innerHTML = '';

  const animItem = bodymovin.loadAnimation({
    wrapper: svgContainer,
    animType: 'svg',
    loop: false,
    autoplay: false,
    path: 'https://cdn.shopify.com/s/files/1/0609/6096/4855/files/quOZHsK7FX_2.json?v=1744883292',
  });

  svgContainer.style.opacity = '0';
  svgContainer.style.transition = 'opacity 0.8s ease-in-out';
  svgContainer.classList.remove('hide');

  setTimeout(() => {
    svgContainer.style.opacity = '1';
    animItem.goToAndPlay(0, true);
  }, 100);

  animItem.addEventListener('complete', function () {
    svgContainer.style.transition = 'opacity 0.8s ease-out';
    svgContainer.style.opacity = '0';
    setTimeout(() => {
      svgContainer.innerHTML = '';
    }, 800);
  });
}


// quantity message section button

class quantityMessageButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.cartOpen.bind(this));
  }
  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }
  async cartOpen(){
    document.querySelector('cart-drawer').open();
    let currentCart = await this.fetchCart();
    var productTitle = [];
    for(var i=0; i < currentCart.items.length; i++) {
        productTitle.push(currentCart.items[i].product_title)
    }
    dataLayer.push({
      event: "Mobile_View_Cart",
      Landing_Page: location.href,
      Previous_Page: document.referrer,
      Cart_Products_Count: currentCart.item_count,
      User_Type: this.getAttribute('data-user-type'),
      Cart_Total: currentCart.total_price / 100,
      Cart_Products: productTitle.join(',')
    });     
  }
 
}

customElements.define('quantity-message-button', quantityMessageButton);

// color-swatch product card
class PcColorSwatch extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }
  handleClick() {
    const dataUrl = this.getAttribute('data-product-url');
    const sectionId = this.getAttribute('data-section-id');
    const variantId = this.getAttribute('data-variant-id');
    const productHandle = this.getAttribute('data-product-handle');
    const currId = this.getAttribute('data-curr-id');
    const viewCard = 'card';
    const dataFetchURL = `/products/${productHandle}?view=${viewCard}&variant=${variantId}&section_id=${sectionId}`;
    const targetElement = this.closest(`[data-id="${currId}"]`);
    fetch(dataFetchURL)
      .then(response => response.text())
      .then(response => {
        const html = new DOMParser().parseFromString(response, 'text/html');
        targetElement.innerHTML = html.getElementById(`${variantId}`).innerHTML;
        targetElement.setAttribute("data-id", variantId);
        Shopify.homepageLazyload();
      })
  }
}

customElements.define('pc-color-swatch', PcColorSwatch);

//quantity-message

class QuantityMessage extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector('quantity-close-button');
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.toggleVisibility.bind(this));
    }
  }

  connectedCallback() {
    this.updateVisibility();
  }

  toggleVisibility() {
    const isVisible = sessionStorage.getItem('bottomNavVisibility') !== 'hidden';
    sessionStorage.setItem('bottomNavVisibility', isVisible ? 'hidden' : 'visible');
    this.updateVisibility();
  }

  updateVisibility() {
    const isVisible = sessionStorage.getItem('bottomNavVisibility') !== 'hidden';
    this.style.display = isVisible ? 'block' : 'none';
  }
}

customElements.define('quantity-message', QuantityMessage);

// product bundle

class ProductsBundle extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.showCouponCode = this.dataset.showCouponCode;
    this.bundleAddedToCart = false;
    this.showCart = true;

    this.addEventListener('click', this.handleClick.bind(this));

    if (this.dataset.showCouponCode === "true") {
      this.couponPopup = this.querySelector(".coupon-popup__overlay");
      this.copyButton = this.querySelector(".coupon-popup__copy-button");
      this.closeButton = this.querySelector(".coupon-popup__close-button");
      this.popupFirstImage = this.querySelector(".coupon-popup__first-image");
      this.popupSecondImage = this.querySelector(".coupon-popup__second-image");
      this.loadingSpinner = this.querySelector(".loading-spinner-container");
      this.copyButton.addEventListener('click', this.copyCouponCode.bind(this));
      this.closeButton.addEventListener('click', this.hideCouponPopup.bind(this));
    }
  }

  async handleClick() {
    if (this.loadingSpinner) this.loadingSpinner.classList.remove("hide");
    const productsList = this.querySelectorAll(".bundle-product");
    for (const product of productsList) {
      const currentCart = await this.fetchCart();
      const productId = product.dataset.bundleProduct;
      const currentQuantity = this.getProductQuantityInCart(currentCart, productId);
      
      if(currentQuantity === 0){
        this.bundleAddedToCart = false;
      }
    }

    if (window.location.pathname === "/collections/crime-scene") {
      if (!this.bundleAddedToCart) {
        await this.addBundleProductsToCart();
        this.bundleAddedToCart = true;
      } else {
        if (this.popupFirstImage) this.popupFirstImage.classList.add("hide");
        if (this.popupSecondImage) this.popupSecondImage.classList.remove("hide");
        if (this.couponPopup) this.couponPopup.classList.remove("hide");
      }
    }
    else{
      this.addBundleProductsToCart()
    }
    if (this.loadingSpinner) this.loadingSpinner.classList.add("hide");
  }

  async addBundleProductsToCart() {
    const productsList = this.querySelectorAll(".bundle-product");

    const couponPopupsList = document.querySelectorAll(".coupon-popup__overlay");
    couponPopupsList.forEach((couponPopup) => {
      if (couponPopup) {
        couponPopup.classList.add("hide");
      }
    });
    
    let items = [];
    let titleArray = [];
    let valueArray = [];
    let sectionTitle;
    
    const currentCart = await this.fetchCart();
    
    for (const product of productsList) {
      const productId = product.dataset.bundleProduct;
      const currentQuantity = this.getProductQuantityInCart(currentCart, productId);
      
      if(currentQuantity === 0){
        this.bundleAddedToCart = false;
      }

      // if (currentQuantity < 1) {
        items.push({'id': productId, 'quantity': 1});
        titleArray.push(product.dataset.title);
        valueArray.push(product.dataset.value / 100);
      // } else {
      //   console.log(`Product ${productId} already has 1 or more in cart. Skipping.`);
      // }
      
      sectionTitle = product.dataset.sectionTitle || "NA";
    }

    if (items.length === 0) {
      if (this.popupFirstImage) this.popupFirstImage.classList.add("hide");
      if (this.popupSecondImage) this.popupSecondImage.classList.remove("hide");
      if (this.couponPopup) this.couponPopup.classList.remove("hide");
      dataLayer.push({
        event: "Coupon_Unlocked_Pop",
        Trigger_Banner: this.getAttribute('data-section-title'),
        code: this.dataset.couponCode,
        previous_landing_page: document.referrer,
        Products_In_Cart: currentCart.item_count,
        Cart_Total: currentCart.total_price / 100
      });
      console.log("No products to add. All selected products already have 1 or more in cart.");
      return;
    }

    dataLayer.push({
      event: "Bundle_Banner",
      products: {
        title: titleArray.join(', '),
        value: valueArray.join(', ')
      },
      section_title: sectionTitle
    });

    dataLayer.push({
      'event': 'addToCart',
      'ecommerce': {
        'currencyCode': 'INR',
          'products': {
            title: titleArray.join(', '),
            value: valueArray.join(', ')
          },
      },
    });

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    const bundleData = {"items": items};

    if (this.cart) {
      bundleData['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
      bundleData['sections_url'] = window.location.pathname;
      this.cart.setActiveElement(document.activeElement);
    }

    config.body = JSON.stringify(bundleData);

    fetch('/cart/add.js', config)
    .then(response => response.json())
    .then(data => {
      if (this.popupFirstImage) this.popupFirstImage.classList.remove("hide");
      if (this.popupSecondImage) this.popupSecondImage.classList.add("hide");
      if (this.couponPopup) this.couponPopup.classList.remove("hide");
      this.cart.renderContents(data, this.showCart);
      dataLayer.push({
        event: "Coupon_Unlocked_Pop",
        Trigger_Banner: this.getAttribute('data-section-title'),
        code: this.dataset.couponCode,
        previous_landing_page: document.referrer,
        Products_In_Cart: currentCart.item_count,
        Cart_Total: currentCart.total_price / 100
      });
      this.cart.addFreebie();
      this.cart.open();
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      if (this.cart && this.cart.classList.contains("is-empty")) {
        this.cart.classList.remove("is-empty");
      }
    });
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  getProductQuantityInCart(cart, productId) {
    const item = cart.items.find(item => item.id.toString() === productId);
    return item ? item.quantity : 0;
  }

  copyCouponCode(e){
    e.preventDefault();
    e.stopPropagation();

    const code = this.dataset.couponCode;
    const currentCart = this.fetchCart();
    navigator.clipboard.writeText(code).then(() => {
      // this.copyButton.textContent = 'Copied';

      dataLayer.push({
        event: "Coupon_Unlocked_Copy",
        Trigger_Banner: this.getAttribute('data-section-title'),
        code: this.dataset.couponCode,
        previous_landing_page: document.referrer,
        Products_In_Cart: currentCart.item_count,
        Cart_Total: currentCart.total_price / 100
      });
      setTimeout(() => {
        this.copyButton.textContent = 'Checkout Now';
        if (this.couponPopup) this.couponPopup.classList.add("hide");
        this.cart.open();
      }, 2000);
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  }

  async hideCouponPopup(e) {
    this.couponPopup.classList.add("hide");
    e.stopPropagation();
    
    const currentCart = await this.fetchCart();
    dataLayer.push({
      event: "Coupon_Unlocked_Close",
      Trigger_Banner: this.getAttribute('data-section-title'),
      code: this.dataset.couponCode,
      previous_landing_page: document.referrer,
      Products_In_Cart: currentCart.item_count,
      Cart_Total: currentCart.total_price / 100
    });
  }
}

customElements.define('products-bundle', ProductsBundle);


class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.updateCountdown = this.updateCountdown.bind(this);
  }

  connectedCallback() {
    this.updateCountdown();
    const countdownInterval = setInterval(this.updateCountdown, 1000);

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        this.updateCountdown();
      }
    });
  }

  updateCountdown() {
    const countdown = this;
    if (!countdown) return;

    const startYear = this.dataset.startyear;
    const startMonth = this.dataset.startmonth;
    const startDay = this.dataset.startday;
    const startHour = this.dataset.starthour;
    const startMinute = this.dataset.startminute;

    const endYear = this.dataset.endyear;
    const endMonth = this.dataset.endmonth;
    const endDay = this.dataset.endday;
    const endHour = this.dataset.endhour;
    const endMinute = this.dataset.endminute;

    const startTime = new Date(startYear, startMonth - 1, startDay, startHour, startMinute);
    const endTime = new Date(endYear, endMonth-1, endDay, endHour, endMinute);
    const currentTime = new Date();
    let countDownBox = this.closest(".count_down--box");

    if (currentTime < startTime) {
      countDownBox.classList.add("hidden");
      return;
    } else {
      countDownBox.classList.remove("hidden");
    }

    const remainingTime = endTime - currentTime;

    if (remainingTime <= 0) {
      countDownBox.classList.add("hidden");
      return;
    }

    const hours = String(Math.floor((remainingTime / (1000 * 60 * 60)) % 24)).padStart(2, "0");
    const minutes = String(Math.floor((remainingTime / (1000 * 60)) % 60)).padStart(2, "0");
    const seconds = String(Math.floor((remainingTime / 1000) % 60)).padStart(2, "0");

    this.animateDigitChange(countdown.querySelector(".hours-1 .current"), hours[0]);
    this.animateDigitChange(countdown.querySelector(".hours-2 .current"), hours[1]);
    this.animateDigitChange(countdown.querySelector(".minutes-1 .current"), minutes[0]);
    this.animateDigitChange(countdown.querySelector(".minutes-2 .current"), minutes[1]);
    this.animateDigitChange(countdown.querySelector(".seconds-1 .current"), seconds[0]);
    this.animateDigitChange(countdown.querySelector(".seconds-2 .current"), seconds[1]);
  }

  animateDigitChange(element, newValue) {
    if (!element || element.textContent === newValue) return;
    const parent = element.parentElement;
    const previousElements = parent.querySelectorAll(".previous, .next");
    previousElements.forEach((el) => el.remove());

    const next = document.createElement("span");
    next.classList.add("next");
    next.textContent = newValue;
    parent.appendChild(next);
    next.offsetHeight;

    setTimeout(() => {
      element.classList.add("previous");
      next.classList.add("current");
    }, 20);

    setTimeout(() => {
      element.remove();
      next.classList.remove("next");
    }, 420);
  }
}

customElements.define("countdown-timer", CountdownTimer);
